export function selectUsers() {
    return (state) => state.users.current; 
}